<div class="card flex flex-col md:flex-row sm:mr-2">
  <div class="p-gutter flex-auto max-w-[1000px]">
    <h3 class="body-2 m-0">Details</h3>

    <div class="operations-scroll mt-4 flex-1 overflow-auto">

      <div #detailsOriginRef class="row row-cols-2 row-cols-sm-3 row-cols-md-4 g-3"
        [ngClass]="details.length>5?'row-cols-lg-6':'row-cols-lg-4'">

        <span *ngFor="let detail  of details" class="cursorP col">
          <a (click)="processOp(detail.route,detailsOriginRef)"
            class="text-dark cursorP text-center hover:bg-primary/10 hover:text-primary trans-ease-out rounded block no-underline"
            [class.disabled]="this.operationStatus.isOperationDisabled(getRouteString(detail.route),detail.id)">
            <mat-icon [svgIcon]="detail.icon" class="icon-xl" color="primary"></mat-icon>
            <div class="body-2 cursorP mt-1">{{ detail.label }}</div>
          </a>
        </span>
      </div>
    </div>
  </div>

</div>